import { render, staticRenderFns } from "./UESPortals.vue?vue&type=template&id=1dbda5db"
import script from "./UESPortals.vue?vue&type=script&lang=js"
export * from "./UESPortals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports